module.exports = __webpack_public_path__ + "static/img/四层(1).de72613.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/Economics/四层(1).png
// module id = 5+ea
// module chunks = 0